namespace TabAurous.Production {
    export interface ProductionBOMForm {
        TransBomId: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        BomProductId: Serenity.LookupEditor;
        AttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        GroupSieveId: StoneSieveLookup;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.StringEditor;
        BomRate: Serenity.DecimalEditor;
        BomAmount: Serenity.DecimalEditor;
    }

    export class ProductionBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Production.ProductionBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductionBOMForm.init)  {
                ProductionBOMForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = StoneSieveLookup;
                var w4 = s.DecimalEditor;

                Q.initFormType(ProductionBOMForm, [
                    'TransBomId', w0,
                    'ItemTypeId', w1,
                    'BomProductId', w2,
                    'AttributeId', w0,
                    'ProductCode', w0,
                    'Attribute', w0,
                    'KaratId', w2,
                    'ShapeId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w3,
                    'MetalColorId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'SettingId', w2,
                    'GroupSieveId', w3,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'Purity', w4,
                    'Pieces', w1,
                    'Weight', w4,
                    'PureWeight', w4,
                    'CalcOnId', w0,
                    'BomRate', w4,
                    'BomAmount', w4
                ]);
            }
        }
    }
}
